import { ApiResponse, TokenData, CompanySegment } from '../models';
import * as http from './http';
import ApiService from './service';

export class CompanySegmentService extends ApiService {
  public async loadAllCompanySegment() {
    const url = `${this.apiDomain}/api/company-segment`;

    const resposne = await http.get<ApiResponse<CompanySegment[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async updateCompanySegment(data: CompanySegment, id?: string) {
    const url = `${this.apiDomain}/api/company-segment/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createCompanySegment(data: CompanySegment) {
    const url = `${this.apiDomain}/api/company-segment`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteCompanySegment(id?: string) {
    const url = `${this.apiDomain}/api/company-segment/${id}`;

    const response = await http.remove<ApiResponse<CompanySegment>>(
      url,
      this.store
    );
    return response.data;
  }
}
